import type { StoryBible, Ledger, ChapterPlan } from '../../types';
import {
  buildApprovedRoadmapPackage,
  storyBibleWithApprovedRoadmap,
  validateApprovedRoadmap,
} from '../../utils/roadmapPersistence.service';

export interface PersistBlueprintApprovalInput {
  storyBible: StoryBible;
  ledger: Ledger;
  approvedAt?: string;
}

export function buildApprovedBlueprintState(input: PersistBlueprintApprovalInput): {
  storyBible: StoryBible;
  ledger: Ledger;
} {
  const approvedAt = input.approvedAt ?? new Date().toISOString();
  return {
    storyBible: {
      ...input.storyBible,
      isBlueprintApproved: true,
      blueprintApproved: true,
      blueprintApprovedAt: approvedAt,
    },
    ledger: input.ledger,
  };
}

export interface PersistRoadmapApprovalInput {
  storyBible: StoryBible;
  ledger: Ledger;
  chapterPlans: ChapterPlan[];
  approvedAt?: string;
}

export function buildApprovedRoadmapState(input: PersistRoadmapApprovalInput): {
  storyBible: StoryBible;
  ledger: Ledger;
  validationError?: string;
} {
  const approvedAt = input.approvedAt ?? new Date().toISOString();
  const targetCount = input.storyBible.targetChapterCount;
  const validation = validateApprovedRoadmap(
    input.chapterPlans,
    targetCount ? { expectedChapterCount: targetCount } : undefined,
  );
  if (!validation.valid) {
    return {
      storyBible: input.storyBible,
      ledger: input.ledger,
      validationError: validation.error,
    };
  }
  const pkg = buildApprovedRoadmapPackage(input.storyBible, input.chapterPlans, approvedAt);
  const storyBible = storyBibleWithApprovedRoadmap(input.storyBible, pkg);
  return { storyBible, ledger: input.ledger };
}

export function resolveWorkspaceStatus(storyBible: StoryBible): 'BLUEPRINT_REVIEW' | 'IDLE' {
  if (!storyBible.isBlueprintApproved && !storyBible.blueprintApproved) {
    return 'BLUEPRINT_REVIEW';
  }
  if (!storyBible.isRoadmapApproved) {
    return 'BLUEPRINT_REVIEW';
  }
  return 'IDLE';
}
